import React from 'react';
import { Link } from 'react-router-dom';

import style from './Home.css';

export default function Home() {
    return (
        <div className='container'>
            <p className='d-flex text-center m-2'>
                The Iowa State University Expense Estimator is intended to help new and continuing students estimate their
                university bill (U-Bill) and the outstanding balance owed or potential financial aid refund after financial aid is
                applied. The information provided is intended to assist students in creating a personal budget and encourage
                responsible loan borrowing.
            </p>
            <hr></hr>
            <h4>Estimates are based on expenses directly billed by the university including:</h4>
            <ul>
                <li>Tuition</li>
                <li>Mandatory Fees</li>
                <li>Housing if living in a University Residence Hall or University Apartment</li>
                <li>University Meal Plan</li>
            </ul>
            <h4>Other expenses that can be included in the tool (Additional Expenses section) are:</h4>
            <ul>
                <li>Housing if NOT living in a University Residence Hall or University Apartment</li>
                <li>Meals other than University Meal Plans</li>
                <li>Books, Course Materials, Supplies, and Equipment</li>
                <li>Personal Expenses such as Travel, Toiletries, and Laundry</li>
            </ul>
            <hr></hr>
            <div>
                <p className='text-center'>
                    This tool is for planning purposes only.<br></br>
                    Your actual U-Bill will be available in Workday prior to the start of each semester.<br></br><br></br>
                    <Link to='/estimator'><button type='button' className={`btn ${style.hoverable}`}>ESTIMATE</button></Link>
                </p>
                <div className='d-flex align-items-center'>
                </div>
            </div>
        </div >
    )
}